import React, { useState, useEffect } from 'react'
import Header from '../../components/Dashboard/Header/Header'
import Navbar from '../../components/Dashboard/Navbar/Navbar'
import ErrorPage from '../ErrorPage/ErrorPage';
import jwt from 'jwt-decode'
import Modal from '../../components/Modal/Modal'

import { useDispatch } from 'react-redux';
import DetailsWindow from '../../components/Dashboard/DetailsWindow/DetailsWindow';
import { getDashOrders } from "../../redux/features/orders/ordersSlice"
import UserList from '../../components/Dashboard/UserList/UserList';

import { useAuthUser } from 'react-auth-kit';
import Search from '../../components/Dashboard/Search/Search';


const DashUsers = () => {

    const auth = useAuthUser();
    document.title = 'Dash Users';


    const [asideMenu, setAsideMenu] = useState(false);

    const [detailsWindow, setDetailsWindow] = useState(false);
    const [userOption, setUserOption] = useState('');
    const [modal, setModal] = useState(false)
    const [modalId, setModalId] = useState('');

    const dispatch = useDispatch();


    useEffect(() => {
        const asideMenuStorage = localStorage.getItem('sidebar');
        if (asideMenuStorage === 'closed') {
            setAsideMenu(true);
        }
        dispatch(getDashOrders());
    }, [asideMenu, dispatch]);



    if (auth().status == 'Admin') {
        return (
            <div className='dashboard-container'>
                <Navbar asideMenu={asideMenu} setAsideMenu={setAsideMenu} />
                <div className="dashboard__main">
                    <Header asideMenu={asideMenu} setAsideMenu={setAsideMenu} />
                    <Search />

                    <div className="main__section">
                        <UserList
                            detailsWindow={detailsWindow}
                            setDetailsWindow={setDetailsWindow}
                            userOption={userOption}
                            setUserOption={setUserOption}
                            modal={modal}
                            setModal={setModal}
                            modalId={modalId}
                            setModalId={setModalId}
                        />

                        <DetailsWindow
                            detailsWindow={detailsWindow}
                            setDetailsWindow={setDetailsWindow}
                            userOption={userOption}
                            setUserOption={setUserOption}
                            modal={modal}
                            setModal={setModal}
                            modalId={modalId}
                            setModalId={setModalId}
                        />

                        <Modal modal={modal} setModal={setModal} modalId={modalId} setDetailsWindow={setDetailsWindow} />
                    </div>
                </div>
            </div>
        )
    } else {
        return <ErrorPage notAdmin />
    }
}

export default DashUsers